<template>
  <div>
    <div class="common-form" style="border-bottom: 1px solid #DCDFE6;">技师分析</div>
    <div>
      <el-col :span="8">
        <div class="cm-box">
          <div class="mt10" style="width:100%">
            <div class="Echarts" style="width:100%">
              <Echartone ref='waiterChartone'></Echartone>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="cm-box">
          <div class="mt10" style="width:100%">
            <div class="Echarts" style="width:100%">
              <!-- <div id="waiterCharttwo"></div> -->
              <Echarttwo style='' ref='waiterCharttwo' />
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="mt10" style="width:100%">
          <div class="Echarts" style="width:100%">
            <Echartthree style='' ref='waiterChartthree' />
          </div>
        </div>
      </el-col>
    </div>
  </div>
</template>
<script>
import StatisticsApi from "@/api/statistics.js";
import Echartone from "./echartone";
import Echarttwo from "./echarttwo";
import Echartthree from "./echartthree";
export default {
  components: {
    Echartone,
    Echarttwo,
    Echartthree
  },
  inject: ["dataModel"],
  data() {
    return {};
  },
  created() {
    this.getData();
    console.log("==========dataModel", this.dataModel.user_table);
  },
  computed: {},
  methods: {
    getData() {
      let first = this.dataModel.user_table.first;
      let second = this.dataModel.user_table.second;
      let three = this.dataModel.user_table.three;
      this.$nextTick(() => {
        // 数据
        const refone = this.$refs.waiterChartone;
        refone.initChart(first);
        // er数据
        const reftwo = this.$refs.waiterCharttwo;
        reftwo.initChart(second);
        // 三
        const refwaiterthree = this.$refs.waiterChartthree;
        refwaiterthree.initChart(three);
      });
    }
  }
};
</script>
<style scoped>
.cm-box {
  padding: 10px;
  margin-bottom: 20px;
}
.grid-content {
  font-weight: 700;
  color: #000;
  font-size: 14px;
}
.pagecharts {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/user111/part/Analysis.vue